module.exports = __webpack_public_path__ + "img/USDCAD.b4a6ef5f.png";